import { Component, computed, inject, signal } from '@angular/core';
import { HistoryFacade } from '../../../../../state/user/history/history.facade';
import { toSignal } from '@angular/core/rxjs-interop';
import { CustomerType } from '../../../../../models/client-configuration';
import { ConfigService } from '../../../../../services/config.service';
import { Util } from '../../../../../util';

@Component({
  selector: 'app-user-history-stats-dialog',
  templateUrl: './user-history-stats-dialog.component.html',
  styleUrls: ['./user-history-stats-dialog.component.scss']
})
export class UserHistoryStatsDialogComponent {
  private readonly configService = inject(ConfigService);
  private readonly historyFacade = inject(HistoryFacade);

  readonly customerType = signal<CustomerType>(this.configService.get().customerType);
  readonly isStatsModalOpen = toSignal(this.historyFacade.isStatsModalOpen$);
  readonly isLoading = toSignal(this.historyFacade.isLoading$);
  readonly historyItem = toSignal(this.historyFacade.historyItem$);
  readonly icon = computed(() => {
    if (this.historyItem()) {
      return Util.resolveIcon(this.historyItem().format, this.historyItem().iconId);
    }

    return null;
  });

  close() {
    this.historyFacade.closeStatsModal();
  }
}
